import React from "react"
import ReactMarkdown from "react-markdown"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import NewspostList from "../components/newspost-list"
import rehypeRaw from 'rehype-raw'
import moment from 'moment'

const NewsPage = ({ location,data }) => {
  const post = data.allStrapiArticle.edges[0].node
  //const post2 = data.allStrapiArticle.max
  const newsposts = data.allStrapiArticle.edges
  const posttag = post.iconfornew==null? "":post.iconfornew.name ;
  //console.log( "default = " + data.allStrapiArticle.edges );
  

  return ( 
    <Layout linkpath="news" hostname={location.hostname}>
      <section className="bg-bg1 grid grid-cols-3 gap-1 w-882 h-1000 py-11px overflow-y-scroll no-scrollbar">
        <NewspostList newsposts={newsposts} />

        <div className="mt-20px w-556 h-954 bg-bg2 bg-no-repeat bg-center">
        <div className="col-span-2 pl-10px pr-9px h-954 flex-grow mb-25px mr-30px overflow-y-scroll no-scrollbar" >
            <div className="inline-flex py-4 px-3 mt-10px">
            <div className={`${posttag} h-24 w-118 flex py-0 px-0 mx-0 my-1 text-center text-posttag justify-center text-white `}><p className=" justify-center self-center">{posttag}</p></div>
            <div className="mx-2 text-right text-posttime-yellow text-posttime ">{/*告知時間：{moment(post.announce).locale('zh-tw').format('llll')}*/}</div>
            </div>
                      <h1 className="px-6 text-postbodytitle font-bold text-black">{post.title}</h1>
        
        <div className="h-11px bg-lineb bg-no-repeat bg-center" />
          <ReactMarkdown
            className="prose text-black px-6 text-postbody" 
            children={post.body} parserOptions={{commonmark: true} } rehypePlugins={[rehypeRaw]}
          />
        </div></div>
      </section>
    </Layout>
  )
}

export const query = graphql`
query ProductQuery($strapiId: Int) {
  strapiArticle(strapiId:{eq: $strapiId}) {
    title
    announce
    updated_at
    iconfornew {
      name
    }

    body
  }
  
  allStrapiArticle(sort: {fields: [announce], order: DESC}) {
	max(field: strapiId)
    edges {
      node {
        strapiId
        title
        iconfornew {
          name
        }

        announce
        body
      }
    }
  }

}
`

export default NewsPage
